import { createContext, useState, useEffect, useContext } from "react";
import { connection } from "utils/apiConnection.ts";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { debounce } from "lodash";
const CartItemsContext = createContext({
  shoppingData: [], //list of items
  updateShoppingList: () => {},
  currentInventory: "",
  prices: {},
  setPrices: () => {},
  itemsCount: 0,
  itemsId: {},
  supplierCount: 0,
  shoppingDataBusiness: [], //list of items based on business
  setShoppingDataBusiness: () => {},
  getCount: () => {},
  isLoading: false,
  setIsLoading: () => {},
});
export default CartItemsContext;
export function CartItemsProvider({ children }) {
  const auth = useContext(WithAuthentication);
  const [shoppingData, setShoppingData] = useState([]);
  const [shoppingDataBusiness, setShoppingDataBusiness] = useState([]);
  const [itemsCount, setItemsCount] = useState(0);
  const [itemsId, setItemsId] = useState({ product: [], basket: [] });
  const [supplierCount, setSupplierCount] = useState(0);
  const [checkOutsData, setCheckOutsData] = useState({});
  const [updater, setUpdater] = useState(false);
  const [currentInventory, setCurrentInventory] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [prices, setPrices] = useState({
    total: 0,
    product: 0,
    basket: 0,
    discount: 0,
    send: 0,
  });
  const updateShoppingList = () => {
    setUpdater((prev) => !prev);
  };
  const getCount = (pavbId, type) => {
    let count = 0;
    if (type == "product") {
      itemsId.product.map((value) => {
        if (value.id == pavbId) {
          count = value.count;
        }
      });
    } else if (type == "basket") {
      itemsId.basket.map((value) => {
        if (value.id == pavbId) {
          count = value.count;
        }
      });
    }
    return count;
  };
  const mainRequest = debounce(() => {
    async function LoadPage() {
      await connection("order/checkout").then((data) => {
        let temp = data;
        for (const k in temp.delivery) {
          temp.delivery[k].fast = { ...data.delivery[k].fast, status: true };
          temp.delivery[k].normal = {
            ...data.delivery[k].normal,
            status: false,
          };
        }

        setCheckOutsData(temp);
      });
      await connection("api/getcartitems").then((data) => {
        setShoppingData(data.data);
        setItemsCount(data.data.length);
        let product = 0,
          basket = 0,
          total = 0,
          discount = 0;
        let itemsIdTemp = { product: [], basket: [] };

        for (let i = 0; i < data.data.length; i++) {
          // product and baskets id
          if (data.data[i].rto_basket_id == "0") {
            itemsIdTemp.product.push({
              id: data.data[i].avb_product_for_order_id,
              count: data.data[i].current_count,
            });
          } else {
            itemsIdTemp.basket.push({
              id: data.data[i].rto_basket_id,
              count: data.data[i].current_count,
            });
          }
          // prices
          discount += parseInt(
            data.data[i].discount * data.data[i].current_count
          );
          total += parseInt(
            (data.data[i].total_price - data.data[i].discount) *
              data.data[i].current_count
          );
          if (data.data[i].rto_basket_id != "0") {
            basket += parseInt(
              (data.data[i].total_price - data.data[i].discount) *
                data.data[i].current_count
            );
          } else if (data.data[i].rto_basket_id == "0") {
            product += parseInt(
              (data.data[i].total_price - data.data[i].discount) *
                data.data[i].current_count
            );
          }
        }

        setItemsId(itemsIdTemp);
        setPrices((prev) => {
          return {
            ...prev,
            total: total,
            discount: discount,
            basket: basket,
            product: product,
          };
        });
      });
      await connection("api/Find_wallets", {
        conditions: `uid/=/${auth.userInfo.id}@@type/=/0`,
      }).then((data) => {
        data[0] && setCurrentInventory(data[0].current_inventory);
        // console.log("data[0].current_inventory", data[0].current_inventory);
      });
    }
    setIsLoading(false);
    LoadPage();
  }, 1000);

  useEffect(() => {
    mainRequest();
  }, [, updater]);
  useEffect(() => {
    setIsLoading(true);
    let supplierId = [];
    shoppingData.map((value) => {
      //  unique supplier ids
      supplierId.push(value.supplier_id);
    });
    let temp = new Set(supplierId);

    setSupplierCount(temp.size);

    //    list of product based on supplier
    let ids = [];
    let productsTemp = [];
    for (let i = 0; i < shoppingData.length; i++) {
      let supplierProduct = {
        supplier: {},
        items: [],
        shopPrice: 0,
        delivery: {},
        regOrderkey: {},
        description: "",
      };
      if (!ids.includes(shoppingData[i].supplier_id)) {
        ids.push(shoppingData[i].supplier_id);
        supplierProduct.supplier = { ...shoppingData[i].supplier_info };
        supplierProduct = {
          ...supplierProduct,
          delivery: checkOutsData.delivery?.[shoppingData[i].supplier_id],
          regOrderkey: checkOutsData.regOrderkey?.[shoppingData[i].supplier_id],
        };
        for (let j = 0; j < shoppingData.length; j++) {
          if (shoppingData[j].supplier_id == shoppingData[i].supplier_id) {
            supplierProduct.items.push(shoppingData[j]);
            supplierProduct.shopPrice +=
              (+shoppingData[j].total_price - +shoppingData[j].discount) *
              +shoppingData[j].current_count;
          }
        }

        productsTemp.push(supplierProduct);
      }
    }

    setShoppingDataBusiness(productsTemp);
    setIsLoading(false);
  }, [shoppingData]);
  // console.log("shoppingDataBusiness", shoppingDataBusiness);
  console.log("shopping**", auth);
  return (
    <>
      <CartItemsContext.Provider
        value={{
          shoppingData,
          updateShoppingList,
          currentInventory,
          prices,
          setPrices,
          itemsCount,
          itemsId,
          supplierCount,
          shoppingDataBusiness,
          setShoppingDataBusiness,
          getCount,
          isLoading,
          setIsLoading,
        }}
      >
        {children}
      </CartItemsContext.Provider>
    </>
  );
}
